<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" :width="800">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item name="id">
                    <a-input v-model:value="form.id" placeholder="请输入id"/>
                </a-form-item>
                <a-form-item name="type">
                    <a-input v-model:value="form.type" placeholder="请输入类型"/>
                </a-form-item>
            </div>
            <a-form-item label="科研机构名称" name="name">
                <a-input v-model:value="form.name" placeholder="请输入科研机构名称"/>
            </a-form-item>
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-item label="成立时间" name="attestationTime">
                        <DatePicker v-model:value="form.attestationTime" placeholder="请输入认定时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="机构性质" name="nature">
                            <DictSelect
                                v-model:value="form.nature"
                                :dict-name="innovation.NATURE"
                                placeholder="请选择"
                            />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row :gutter="20">
                <a-col :span="12">
                    <a-form-item label="联系人" name="contacts">
                        <a-input v-model:value="form.contacts" placeholder="请输入联系人"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人电话" name="contactsPhone">
                        <a-input v-model:value="form.contactsPhone" placeholder="请输入联系人电话"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-form-item label="学科领域或重点研究方向" name="researchDirection">
                <a-input v-model:value="form.researchDirection" placeholder="学科领域或重点研究方向"/>
            </a-form-item>
            <a-form-item label="合作单位，多个用逗号隔开" name="cooperationUnit">
                <a-textarea v-model:value="form.cooperationUnit" placeholder="请输入合作单位，中间用英文','隔开"
                            :auto-size="{minRows:3,maxRows:5}"/>
            </a-form-item>
            <a-row :gutter="24">
                <a-col :span="24">
                    <a-form-item label="近年来的主要科研成果" name="achievements">
                        <a-input v-model:value="form.achievements"/>
                    </a-form-item>
                </a-col>

            </a-row>
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-item label="累计有效知识产权（件）" name="intellectual">
                        <a-input-number v-model:value="form.intellectual" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="其中发明专利（件）" name="invention">
                        <a-input-number v-model:value="form.invention" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="总人数" name="totalStaff">
                        <a-input-number v-model:value="form.totalStaff" :min="0" :precision="0" style="width: 100%" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="其中科研人员（人）" name="fixedsPersonnel">
                        <a-input-number v-model:value="form.fixedsPersonnel" :min="0" :precision="0" style="width: 100%" />
                    </a-form-item>
                </a-col>
            </a-row>
            <a-divider orientation="left">科研人员结构</a-divider>
            <a-row :gutter="20">

                <a-col :span="8">
                    <a-form-item label="正高级人数" name="senior">
                        <a-input-number v-model:value="form.senior" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="副高级人数" name="subSenior">
                        <a-input-number v-model:value="form.subSenior" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="中级人数" name="middle">
                        <a-input-number v-model:value="form.middle" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="博士人数" name="doctor">
                        <a-input-number v-model:value="form.doctor" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="硕士人数" name="master">
                        <a-input-number v-model:value="form.master" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="学士人数" name="bachelor">
                        <a-input-number v-model:value="form.bachelor" :min="0" :precision="0" style="width: 100%"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-form-item label="机构简介" name="profile">
                <a-textarea v-model:value="form.profile" placeholder="请输入机构简介" :auto-size="{minRows:3,maxRows:5}"/>
            </a-form-item>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import {formMixin} from "@/mixins";
// import dataCheck from "@/utils/dataCheck";
import {ScientificApi} from "@/api/innovationService";
import {companyOriginInfo} from "@/api/tenantService";
import {innovation} from "@/config/variableConfig"
import DictSelect from "@/components/other/DictSelect";
import DatePicker from "@/components/form/datePicker/DatePicker";

export default {
    name: "addOrEditModal",
    mixins: [formMixin],
    components: {DictSelect,DatePicker},
    data() {
        return {
            options:[],
            innovation,
            /*表单绑定值与验证规则定义*/
            form: {
                id: null,
                achievements: null,
                bachelor: null,
                cooperationUnit: null,
                doctor: null,
                invention: null,
                nature: null,
                master: null,
                middle: null,
                name: null,
                totalStaff: null,
                profile: null,
                researchDirection: null,
                subSenior: null,
                attestationTime: null,
                intellectual: null,
                type: null,
                senior: null,
                contacts: null,
                contactsPhone: null,
                fixedsPersonnel: null,
            },
            rules: {
                id:[],
                achievements: [],
                bachelor: [],
                cooperationUnit: [],
                doctor: [],
                invention: [],
                nature: [],
                master: [],
                middle: [],
                name: [],
                totalStaff: [],
                profile: [],
                researchDirection: [],
                subSenior: [],
                attestationTime: [],
                intellectual: [],
                senior: [],
                type: [],
                contacts: [],
                contactsPhone: [],
                fixedsPersonnel: [],
            },
            /*提交表单地址*/
            submitUrl: ScientificApi.saveOrUpdate
        }
    },
    mounted() {
        this.getCompany()
    },
    methods: {
        filterOption(input, option) {
            return (
                option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        getCompany() {
            this.getAction({
                url: companyOriginInfo.List
            }).then(res => {
                this.options = res
            })
        }
    },
}
</script>
<style scoped lang="less">

</style>
